<template>
  <b-accordion>
    <b-accordion-item
      :model-value="statusAccordion === 'deleted' ? false : showContent"
      @update:model-value="value => (showContent = value)"
      header-class="header-color"
      :class="`${statusAccordion === 'deleted' ? 'hide-dropdown' : ''}`"
    >
      <template #title>
        <div class="header-wrapper">
          <div class="header-info">
            <strong>{{ title }}</strong>
            <h5 v-if="statusAccordion === 'created'"><b-badge variant="success">Created</b-badge></h5>
            <h5 v-if="statusAccordion === 'deleted'"><b-badge variant="danger">Deleted</b-badge></h5>
            <h5 v-if="statusAccordion === 'updated'"><b-badge variant="primary">Edited</b-badge></h5>
            <h5 v-if="isThereAConfict"><b-badge variant="warning">Conflict</b-badge></h5>
          </div>
          <div class="header-checkbox" @click.stop="() => {}">
            <b-form-checkbox size="lg" v-model="checkBoxState" v-if="checkboxLabel" /><span
              @click="checkBoxState = !checkBoxState"
              >{{ checkboxLabel }}</span
            >
          </div>
        </div>
      </template>
      <div class="side-by-side-view-container">
        <table>
          <tbody :data-testid="title">
            <tr>
              <th class="padding-master-branch-badges">
                <h5>
                  <b-badge class="badge-color-master" variant="danger">{{ t('diffModal.master') }}</b-badge>
                </h5>
              </th>
              <th class="padding-master-branch-badges">
                <h5>
                  <b-badge class="badge-color-branch" variant="primary">{{ t('diffModal.myBranch') }}</b-badge>
                </h5>
              </th>
            </tr>
            <template v-for="field in fields" :key="field.label">
              <fieldBranchChange :field="field" :status-branch="statusBranch" :status-master="statusMaster" />
            </template>
          </tbody>
        </table>
      </div>
    </b-accordion-item>
  </b-accordion>
</template>
<script setup>
import fieldBranchChange from './field-branch-change.vue';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  title: String,
  statusMaster: String,
  statusBranch: String,
  modalType: String,
  fields: Array,
  id: String,
});

const { t } = useI18n({ useScope: 'global' });

const statusAccordion = computed(() => {
  switch (props.modalType) {
    case 'rebase':
      return props.statusMaster;
    default:
      return props.statusBranch;
  }
});

const checkboxLabel = computed(() => {
  if (isTypeRebase.value) {
    return t('diffModal.addChangeToBranch');
  }
  if (isTypeMerge.value) {
    return t('diffModal.mergeChange');
  }
  return null;
});

const isThereAConfict = computed(() => {
  return props.statusMaster && props.statusBranch;
});

const isTypeRebase = computed(() => props.modalType === 'rebase');
const isTypeMerge = computed(() => props.modalType === 'merge');

const accordeonState = defineModel();
const checkBoxState = computed({
  get: () => {
    if (isTypeRebase.value) {
      return accordeonState.value === 'master';
    }
    return accordeonState.value === 'branch';
  },
  set: value => {
    if (isTypeRebase.value) {
      accordeonState.value = value ? 'master' : 'branch';
    } else {
      accordeonState.value = value ? 'branch' : 'master';
    }
  },
});

const showContent = ref(false);
</script>
<style lang="scss" scoped>
@import '@versions/x/styles/variables.scss';

.side-by-side-view-container {
  display: flex;
}

.toggle-change {
  padding-left: 30px;
}

.header-info {
  display: flex;
  align-items: baseline;
  gap: 1em;

  > h5 {
    margin-bottom: 0px;
  }
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1em;
}

.padding-master-branch-badges {
  padding: 0 1em;
}

table {
  width: 100%;
}

:deep(.btn-sm) {
  width: 200px;
}

:deep(.badge) {
  margin-left: 0px;
}

:deep(.accordion-body) {
  padding: 1em 0;
}

.hide-dropdown {
  :deep(.accordion-button::after) {
    visibility: hidden;
  }
}

:deep(.badge.badge-color-master) {
  background-color: $commandersact !important;
}

:deep(.badge.badge-color-branch) {
  background-color: $commandersactblue !important;
}

:deep(.btn-outline-danger) {
  --bs-btn-border-color: #{$commandersact} !important;
  --bs-btn-active-bg: #{$commandersact} !important;
  --bs-btn-color: #{$commandersact} !important;
  --bs-btn-active-border-color: #{$commandersact} !important;
}

:deep(.btn-outline-primary) {
  --bs-btn-border-color: #{$commandersactblue} !important;
  --bs-btn-active-bg: #{$commandersactblue} !important;
  --bs-btn-color: #{$commandersactblue} !important;
  --bs-btn-active-border-color: #{$commandersactblue} !important;
}
</style>
